import React from 'react';
import { Link } from 'react-router-dom';
import { Col, Row } from 'reactstrap';
import moment from 'moment';
import ObjectID from 'bson-objectid';

import './NotificationRow.scss';

const isToday = (someDate) => {
	const today = new Date()
	return someDate.getDate() == today.getDate() &&
	  someDate.getMonth() == today.getMonth() &&
	  someDate.getFullYear() == today.getFullYear()
}

const NotificationRow = ({ notification }) => {

	let timestamp = ObjectID(notification._id).getTimestamp();
	let createdAt = isToday(new Date(timestamp)) ? moment(timestamp).format('hh:mm') : moment(timestamp).format('DD/MM/YYYY');

	let image;
	if (notification.type === 'reward_received')
		image = require('../../assets/images/reward.svg').default;


	return <Row className="notification-row">
			<Col className="h-100" sm="12">
				<Link className="d-flex align-items-center justify-content-between h-100"  to={notification.link}>
					<div className="d-flex align-items-center">
						{image ? (
							<img
								src={image}
								className="rounded-circle avatar-sm mr-4"
								alt="notification"
							/>
						) : null}
						<p className="text-truncate font-size-14 d-inline mb-0">
							{notification.title}
						</p>
					</div>
					<small className="mb-0">{createdAt}</small>
				</Link>
			</Col>
		</Row>;
};

export default NotificationRow;
